import LTR from "@brand-icons/global/ui-check/ui-check-ltr.svg";

import { iconFactory } from "../iconFactory";

export const UiCheckIcon = iconFactory("UiCheckIcon", LTR);
